import { Pipe, PipeTransform, inject } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateCheck',
  standalone: false,
})
export class DateCheckPipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  transform(value: string | Date | null | undefined): any {
    // Check if the value is null, undefined, or an empty array
    if (
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0)
    ) {
      // Return a default value or simply the value itself based on your requirements
      return value;
    }
    // Attempt to parse the value as a date
    const parsedDate = new Date(value);
    // Check if the value is a valid date
    if (!isNaN(parsedDate.getTime())) {
      // If valid, format it using the DatePipe
      return this.datePipe.transform(parsedDate, 'mediumDate');
    }
    // If not a date, return the original value
    return value;
  }
}
